import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/base/SEOHead';

export default function NotFound() {
  return (
    <>
      <SEOHead
        title="页面未找到 - 内容导航平台"
        description="您访问的页面不存在，请返回首页浏览更多内容。内容导航平台提供科技数码、影视娱乐、生活百科、教育学习、健康养生等分类导航。"
        keywords="404,页面未找到,内容导航"
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-16 flex items-center justify-center min-h-[70vh]">
          <div className="text-center px-4">
            <div className="text-7xl font-bold text-primary-500 mb-4" style={{ fontFamily: 'var(--font-heading)' }}>404</div>
            <h1 className="text-xl font-semibold text-foreground-950 mb-3">页面未找到</h1>
            <p className="text-foreground-600 mb-8">抱歉，您访问的页面不存在或已被移除</p>
            <Link
              to="/"
              className="px-6 py-3 bg-primary-500 text-white rounded-full font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              返回首页
            </Link>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}